export default __webpack_public_path__ + "static/media/eclinic_video_final.a1a66be3.webm";